import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { IProduct } from "../../redux/modules/products";
import { IOperation, getOperationsForProduct } from "../../redux/modules/operations";
import { formatPrice, formatDate } from "../../utils";
import "./product-operation-list.css";

interface ProductOperationListProps {
  product: IProduct;
}

class ProductOperationList extends React.Component<ProductOperationListProps> {
  renderSupplyOperations() {
    const supplyOperations = this.props.product.operations?.filter((o) => o.type === "SUPPLY");

    if (!supplyOperations?.length) {
      return (
        <div className="product-operation-list__empty">
          <p className="product-operation-list__empty-text">Жодних операцій поповнення</p>
        </div>
      );
    }

    const operations = supplyOperations
      .sort((o1, o2) => (new Date(o1.date) < new Date(o2.date) ? -1 : 1))
      .map((operation: IOperation) => {
        return (
          <div className="product-operation-list__item product-operation-list__item--supply" key={operation.id}>
            <div className="product-operation-list__item-content">
              <div className="product-operation-list__item-date">
                <span className="product-operation-list__item-icon">📅</span>
                {formatDate(operation.date)}
              </div>
              <div className="product-operation-list__item-amount">
                <span className="product-operation-list__item-label">Кількість:</span>
                <span className="product-operation-list__item-value">
                  {operation.amount} {this.getLocalizedUnitType()}
                </span>
              </div>
              <div className="product-operation-list__item-price">
                <span className="product-operation-list__item-label">Собівартість:</span>
                <span className="product-operation-list__item-value">{formatPrice(operation.amount * this.props.product.basePrice)} грн</span>
              </div>
            </div>
          </div>
        );
      });

    return <div className="product-operation-list__items">{operations}</div>;
  }

  renderSellOperations() {
    const sellOperations = this.props.product.operations?.filter((o) => o.type === "SELL");

    if (!sellOperations?.length) {
      return (
        <div className="product-operation-list__empty">
          <p className="product-operation-list__empty-text">Жодних операцій продажу</p>
        </div>
      );
    }

    const operations = sellOperations
      .sort((o1, o2) => (new Date(o1.date) < new Date(o2.date) ? -1 : 1))
      .map((operation: IOperation) => {
        return (
          <div className="product-operation-list__item product-operation-list__item--sell" key={operation.id}>
            <div className="product-operation-list__item-content">
              <div className="product-operation-list__item-date">
                <span className="product-operation-list__item-icon">📅</span>
                {formatDate(operation.date)}
              </div>
              <div className="product-operation-list__item-client">
                <span className="product-operation-list__item-label">Клієнт:</span>
                <Link to={`/client/${operation.clientId}?tab=products`} className="product-operation-list__item-link">
                  {operation?.client?.name}
                </Link>
              </div>
              <div className="product-operation-list__item-amount">
                <span className="product-operation-list__item-label">Кількість:</span>
                <span className="product-operation-list__item-value">
                  {operation.amount} {this.getLocalizedUnitType()}
                </span>
              </div>
              <div className="product-operation-list__item-price">
                <span className="product-operation-list__item-label">Прибуток:</span>
                <span className="product-operation-list__item-value product-operation-list__item-value--profit">
                  {formatPrice((operation.sellPrice - this.props.product.basePrice) * operation.amount)} грн
                </span>
              </div>
            </div>
          </div>
        );
      });

    return <div className="product-operation-list__items">{operations}</div>;
  }

  renderUseOperations() {
    const useOperations = this.props.product.operations?.filter((o) => o.type === "USE");

    if (!useOperations?.length) {
      return (
        <div className="product-operation-list__empty">
          <p className="product-operation-list__empty-text">Жодних операцій використання</p>
        </div>
      );
    }

    const operations = useOperations
      .sort((o1, o2) => (new Date(o1.date) < new Date(o2.date) ? -1 : 1))
      .map((operation: IOperation) => {
        return (
          <div className="product-operation-list__item product-operation-list__item--use" key={operation.id}>
            <div className="product-operation-list__item-content">
              <div className="product-operation-list__item-date">
                <span className="product-operation-list__item-icon">📅</span>
                {formatDate(operation.date)}
              </div>
              <div className="product-operation-list__item-amount">
                <span className="product-operation-list__item-label">Кількість:</span>
                <span className="product-operation-list__item-value">
                  {operation.amount} {this.getLocalizedUnitType()}
                </span>
              </div>
            </div>
          </div>
        );
      });

    return <div className="product-operation-list__items">{operations}</div>;
  }

  renderOperations() {
    if (!this.props.product.operations || this.props.product.operations.length === 0) {
      return (
        <div className="product-operation-list__empty">
          <p className="product-operation-list__empty-text">Ще немає жодної операції з товаром</p>
        </div>
      );
    }

    return (
      <div className="product-operation-list__sections">
        <div className="product-operation-list__section">
          <div className="product-operation-list__section-header product-operation-list__section-header--sell">
            <span className="product-operation-list__section-icon">💰</span>
            <h3 className="product-operation-list__section-title">Продаж</h3>
          </div>
          <div className="product-operation-list__section-content">{this.renderSellOperations()}</div>
        </div>

        <div className="product-operation-list__section">
          <div className="product-operation-list__section-header product-operation-list__section-header--supply">
            <span className="product-operation-list__section-icon">📥</span>
            <h3 className="product-operation-list__section-title">Поповнення</h3>
          </div>
          <div className="product-operation-list__section-content">{this.renderSupplyOperations()}</div>
        </div>

        <div className="product-operation-list__section">
          <div className="product-operation-list__section-header product-operation-list__section-header--use">
            <span className="product-operation-list__section-icon">📤</span>
            <h3 className="product-operation-list__section-title">Використання</h3>
          </div>
          <div className="product-operation-list__section-content">{this.renderUseOperations()}</div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="product-operation-list">
        <div className="product-operation-list__header">
          <h2 className="product-operation-list__title">Операції з товаром {this.props.product.name}</h2>
        </div>
        {this.renderOperations()}
      </div>
    );
  }

  getLocalizedUnitType() {
    return this.props.product.unitType === "piece" ? "шт" : "мл";
  }
}

export default ProductOperationList;
